import * as React from 'react';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import { ContextualMenu, IContextualMenuProps } from '@fluentui/react/lib/ContextualMenu';
import DueDateMenuPicker from '../components/DueDateMenuPicker';
import { SET_DUE_DATE_COMMAND_ID, EDIT_DUE_DATE_COMMAND_ID } from '../constants';

export default function renderDueDateMenuPickerAsCalloutWithOptions(
    item?: IContextualMenuProps,
    directionalHint?: DirectionalHint,
    onDismiss?: () => void
) {
    if (!item) {
        return null;
    }

    if (item.id === SET_DUE_DATE_COMMAND_ID || item.id === EDIT_DUE_DATE_COMMAND_ID) {
        const {
            projectId,
            assetId,
            selectedDate,
            isCompleted,
            onSetDueDate,
            onRemoveDueDate,
            onSetComplete,
            deleteTaskOnDateRemoval,
        } = item?.items[0].data;

        return (
            <Callout
                target={item.target}
                setInitialFocus={true}
                alignTargetEdge={true}
                isBeakVisible={false}
                onDismiss={onDismiss}
                directionalHint={directionalHint || DirectionalHint.rightTopEdge}>
                <DueDateMenuPicker
                    projectId={projectId}
                    assetId={assetId}
                    selectedDate={selectedDate}
                    isCompleted={isCompleted}
                    deleteTaskOnDateRemoval={deleteTaskOnDateRemoval}
                    dismissMenu={item.onDismiss}
                    onSetDueDate={onSetDueDate}
                    onRemoveDueDate={onRemoveDueDate}
                    onSetComplete={onSetComplete}
                />
            </Callout>
        );
    }

    return <ContextualMenu {...item} />;
}
